/**
 * Row selection for the runs table: every row (`"all"`) or a set of row keys.
 */
export type RunSelection = "all" | Set<string | number>

export const RUNS_VIEW_MODE = {
  RUNS: "runs",
  SIMULATIONS: "simulations",
} as const

export type RunsViewMode = (typeof RUNS_VIEW_MODE)[keyof typeof RUNS_VIEW_MODE]

export const DEFAULT_RUNS_VIEW_MODE = RUNS_VIEW_MODE.RUNS

export function isRunsViewMode(
  value: string | null | undefined,
): value is RunsViewMode {
  return value === RUNS_VIEW_MODE.RUNS || value === RUNS_VIEW_MODE.SIMULATIONS
}
